import { getGlobalClassNames, FontSizes, AnimationVariables } from '../../Styling';
var GlobalClassNames = {
    root: 'ms-GroupedList',
    group: 'ms-GroupedList-group',
    link: 'ms-Link',
    listCell: 'ms-List-cell'
};
var beziers = {
    easeInOutSine: 'cubic-bezier(0.445, 0.050, 0.550, 0.950)'
};
export var getStyles = function (props) {
    var theme = props.theme, className = props.className;
    var palette = theme.palette;
    var classNames = getGlobalClassNames(GlobalClassNames, theme);
    return {
        root: [
            classNames.root,
            {
                position: 'relative',
                fontSize: FontSizes.small,
                selectors: (_a = {},
                    _a["& :global(." + classNames.listCell + ")"] = {
                        minHeight: 36
                    },
                    _a)
            },
            className
        ],
        group: [
            classNames.group,
            {
                transition: "background-color " + AnimationVariables.durationValue2 + " " + beziers.easeInOutSine
            }
        ],
        groupIsDropping: [
            {
                backgroundColor: palette.neutralLight
            }
        ]
    };
    var _a;
};
//# sourceMappingURL=GroupedList.styles.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/office-ui-fabric-react/lib/components/GroupedList/GroupedList.styles.js
// module id = 737
// module chunks = 0